<div class="container-fluid skin-home">
  <br>
  <br>

  <div class="row align-content-center four-images">
    <div class="col-md-3">
      <img alt="wallpaper skin 1" src="../../../assets/img/wallpaper-1.jpg" />
    </div>
    <!-- <div class="col-md-3">
      <img alt="wallpaper skin 2" src="../../../assets/img/wallpaper-skin-iot-2.png" />
    </div>
    <div class="col-md-3">
      <img alt="wallpaper skin 3" src="../../../assets/img/wallpaper-skin-iot-3.png" />
    </div>
    <div class="col-md-3">
      <img alt="wallpaper skin 3" src="../../../assets/img/wallpaper-skin-iot-4.png" />
    </div> -->
  </div>

</div>